var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from "vue-property-decorator";
let WatermarkCircle = class WatermarkCircle extends Vue {
    constructor() {
        super(...arguments);
        this.watermarkTitle = "Paymenterio";
    }
};
__decorate([
    Prop()
], WatermarkCircle.prototype, "type", void 0);
__decorate([
    Prop()
], WatermarkCircle.prototype, "size", void 0);
WatermarkCircle = __decorate([
    Component
], WatermarkCircle);
export default WatermarkCircle;
